import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

export function handleHttpError(error: HttpErrorResponse) {
  let errorMessage = 'An unknown error occurred!';

  if (error.error instanceof ErrorEvent) {
    // Client-side error
    errorMessage = `Client-side error: ${error.error.message}`;
  } else {
    // Backend error
    switch (error.status) {
      case 401:
        errorMessage = 'Unauthorized request. Please log in again.';
        break;
      case 403:
        errorMessage = 'Access denied. You do not have permission.';
        break;
      case 404:
        errorMessage = 'Resource not found.';
        break;
      case 500:
        errorMessage = 'Internal server error. Please try again later.';
        break;
      default:
        errorMessage = `Unexpected error: ${error.status}`;
    }
  }
  return throwError(() => error);
}
